import '../styles/institutes.css';
import React, { useEffect, useState } from 'react';
import location from '../assests/Images/location.svg';
import Footer from "../components/footer";
import { Modal, Spinner } from "react-bootstrap"; // Added Spinner import

import { API_BASE_URL } from '../config/api';

const Institues = () => {
    const [selectedService, setSelectedService] = useState([]); // State to store the service details
    const [showModal, setShowModal] = useState(false); // Changed from showOffcanvas
    const [isClosing, setIsClosing] = useState(false); // Add closing state for animation
    const [institues, setInstitues] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(true); // Add loading state

    const filteredInstitutes = institues.filter((institute) => {
        const query = searchQuery.toLowerCase();
        return (
          institute.name?.toLowerCase().includes(query) ||
          institute.city?.toLowerCase().includes(query) ||
          institute.state?.toLowerCase().includes(query) ||
          institute.state_verbose?.toLowerCase().includes(query) ||
          institute.address?.toLowerCase().includes(query) ||
          institute.mti_no?.toString().toLowerCase().includes(query)
        );
    });

    const handleCloseModal = () => {
        setIsClosing(true);
        setTimeout(() => {
          setShowModal(false);
          setIsClosing(false);
        }, 300); // Match the CSS transition duration
    };

    const handleShowModal = (index) => {
        setSelectedService(index);
        setIsClosing(false);
        setShowModal(true);
    };

    useEffect(() => {
        const fetchInstitutes = async () => {
            try {
                setLoading(true); // Set loading to true before fetching
                const response = await fetch(`${API_BASE_URL}/api/learning/institutes/`);
                const data = await response.json();
                setInstitues(data);
                console.log("institutes", data);
            } catch (error) {
                console.error('Error fetching institutes:', error);
            } finally {
                setLoading(false); // Set loading to false after fetching (success or error)
            }
        };

        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                handleCloseModal();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        fetchInstitutes();

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [])

    const NextService = () => {
        if (selectedService < filteredInstitutes.length) {
            setSelectedService(selectedService + 1);
        }
        else {
            console.log("index went out");
        }
    }

    const PrevServices = () => {
        if (selectedService !== 0) {
            setSelectedService(selectedService - 1);
        }
        else {
            console.log("index went out");
        }
    }

    // Loading spinner component
    const LoadingSpinner = () => (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
            <div className="text-center">
                <Spinner animation="border" role="status" style={{ width: '3rem', height: '3rem', color: 'green' }}>
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
                <p className="mt-3 text-muted">Loading institutes...</p>
            </div>
        </div>
    );

    return (
        <div style={{ paddingTop: "100px" }}>
            <div className="institutes">
                <h1 className="section-title fs-2">Institutes</h1>
                <p className="services-header-txt text-start">
                    Successful maritime education combines traditional knowledge with modern teaching methods while maintaining strong mentorship connections. Regular evaluation and adaptation of programs ensures they remain relevant to industry needs while providing comprehensive support for aspiring seafarers.
                </p>
                
                {!loading && (
                    <div className="institues-filter" style={{ padding: "30px 0px" }}>
                        <input
                            type="text"
                            style={{ padding: "10px", marginTop: "20px",width:"100%",borderRadius:"8px",border:"1px solid grey" }}
                            placeholder="Search for institutes..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                )}

                {loading ? (
                    <LoadingSpinner />
                ) : (
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4 services3">
                        {filteredInstitutes.length > 0 ? (
                            filteredInstitutes.map((institute, index) => (
                                <div className="col" key={index} onClick={() => handleShowModal(index)}>
                                    <div id="institue-card" className="h-100">
                                        <div className="card-header">
                                            <p className="card-text">MTI_NO : <span className="color-gree">{institute.mti_no}</span></p>
                                            <button type="button" onClick={() => { handleShowModal(index) }} className="card-button">view more</button>
                                        </div>
                                        <div className="card-body">
                                            <p className="card-title">{institute.name}</p>
                                        </div>
                                        <div className="card-footer">
                                            <img src={location} alt="Location" className="card-img-top" />
                                            <p5>{institute.city}, {institute.state_verbose}</p5>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="col-12">
                                <div className="text-center py-5">
                                    <p className="text-muted">No institutes found matching your search criteria.</p>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
            <Footer />

            <div className="model-comp">
                <Modal
                    show={showModal}
                    onHide={handleCloseModal}
                    centered
                    className={`services-popup ${isClosing ? 'closing' : ''}`}
                    size="lg"
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{filteredInstitutes[selectedService]?.name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='offcanvas-body'>
                            <div className="offcanvas-details">
                                <p2 className="offcanvas-text"><span className="offcanvas-table-head">MTI NO</span> <span className="color-gree">{filteredInstitutes[selectedService]?.mti_no}</span></p2>
                                <p2 className="offcanvas-text"><span className="offcanvas-table-head">Address</span> {filteredInstitutes[selectedService]?.address}</p2>
                                <p2 className="offcanvas-text"><span className="offcanvas-table-head">City</span> {filteredInstitutes[selectedService]?.city}</p2>
                                <p2 className="offcanvas-text"><span className="offcanvas-table-head">State</span> {filteredInstitutes[selectedService]?.state_verbose}</p2>
                                <p2 className="offcanvas-text"><span className="offcanvas-table-head">Pincode</span> {filteredInstitutes[selectedService]?.pincode}</p2>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="services-popup-footer">
                        <div className="offcanvas-buttons" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <button className="canvas-next-button" onClick={PrevServices}>Back</button>
                            <button className="canvas-next-button" onClick={NextService} disabled={(selectedService + 1) === filteredInstitutes.length}>Next Institute</button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    )
}

export default Institues;